module.exports = __webpack_public_path__ + "static/eventDetail2-7b9add5ba8794a368efa5fa6998d11ac.png";